module.exports = __webpack_public_path__ + "static/img/7.55d6152.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/travel/en/7.jpg
// module id = snfW
// module chunks = 2